import {
  TextInput,
  required,
  SimpleForm,
  SelectInput,
  ReferenceArrayInput,
  ArrayInput,
  SimpleFormIterator,
  AutocompleteArrayInput,
  maxLength,
  minLength,
  email,
  useLoading,
  SelectArrayInput,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import { GenderOptionsId } from "utils/choices";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { checkPermission } from "../../../server/security/utils";
import { getPermissions } from "../../../auth/security/securityUtils";
import permissions from "app/permissions";
import { useState } from "react";
import { settings } from "app";

import NodeEmployeeContent from "./components/NodeEmployeesContent";
import { nameCyrillicRegexValidator } from "utils/validations";
import { accountRequests } from "api/accountApi";
import { employeeRequests } from "api/employeeApi";

const SaveForm = ({ isEdit }) => {
  const [structuralUnitId, setStructuralUnitId] = useState({});

  const loading = useLoading();

  return (
    <SimpleForm>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Google Workspace имейл"
            source="corporateEmail"
            readOnly={isEdit}
            validate={[required(), email()]}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <SelectInput
            label="Пол"
            source="userInfo.gender"
            choices={GenderOptionsId}
            validate={[required()]}
            fullWidth
            readOnly={loading && isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="ЕГН"
            source="userInfo.personId"
            fullWidth
            readOnly={loading && isEdit}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Име"
            source="userInfo.firstName"
            validate={[required(), minLength(2), maxLength(30), nameCyrillicRegexValidator]}
            fullWidth
            readOnly={loading && isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Презиме"
            source="userInfo.secondName"
            validate={[minLength(2), maxLength(30), nameCyrillicRegexValidator]}
            fullWidth
            readOnly={loading && isEdit}
            defaultValue={""}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Фамилия"
            source="userInfo.lastName"
            validate={[required(), minLength(2), maxLength(30), nameCyrillicRegexValidator]}
            fullWidth
            readOnly={loading && isEdit}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={0}
      >
        <Grid
          item
          xs={12}
          md={12}
        >
          <ArrayInput
            label="Телефони за контакт"
            source="phones"
          >
            <SimpleFormIterator
              disableReordering
              inline
              disableClear
              sx={settings.style.iteratorWithoutGap}
            >
              <TextInput
                label="Телефон"
                source="phoneNumber"
                readOnly={loading && isEdit}
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceArrayInput
            source="scientificDegrees"
            reference={employeeRequests.getScientificDegreesSelect()}
          >
            <SelectArrayInput
              optionText="name"
              label="Научна степен"
              fullWidth
              readOnly={loading && isEdit}
            />
          </ReferenceArrayInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
        >
          <Grid
            item
            xs={12}
          >
            <NodeEmployeeContent
              structuralUnitId={structuralUnitId}
              setStructuralUnitId={setStructuralUnitId}
            />
          </Grid>
        </Grid>
      </Grid>
      <Typography
        sx={{ marginTop: 3 }}
        color="primary"
      >
        Данни за ЛК
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            label="Номер на лична карта"
            source="idCardDetail.number"
            validate={[maxLength(9, "Въведете точно 9 символа"), minLength(9, "Въведете точно 9 символа")]}
            readOnly={loading && isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            label="Дата на издаване на лична карта"
            source="idCardDetail.issuedOn"
            noTime
            required={false}
            readOnly={loading && isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            label="Издател на лична карта"
            source="idCardDetail.issuedBy"
            readOnly={loading && isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TextInput
            label="Адрес по лична карта"
            source="idCardDetail.address"
            readOnly={loading && isEdit}
          />
        </Grid>
      </Grid>
      {isEdit && (
        <>
          {" "}
          <Typography color="primary">Сигурност</Typography>
          <Grid
            container
            spacing={1}
          >
            <ReferenceArrayInput
              source="roleIds"
              reference={accountRequests.getRolesSelect()}
            >
              <AutocompleteArrayInput
                optionText="name"
                readOnly={!checkPermission(getPermissions(), permissions.canAttachRolesToEmployees)}
                label="Роли"
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                fullWidth
              />
            </ReferenceArrayInput>
          </Grid>
          <Grid
            container
            spacing={1}
          >
            <ReferenceArrayInput
              source="permissionIds"
              reference={accountRequests.getPermissionsSelect()}
            >
              <AutocompleteArrayInput
                optionText="name"
                readOnly={!checkPermission(getPermissions(), permissions.canAttachPermissionsToEmployees)}
                label="Права"
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                fullWidth
              />
            </ReferenceArrayInput>
          </Grid>
        </>
      )}
    </SimpleForm>
  );
};

export default SaveForm;
